import React from "react"

import { useDispatch } from "react-redux"
import { setCompanyId } from "../../../redux/inscription"
import { ICompany } from "../../../interfaces/company"

interface IProps {
  company: ICompany
}

const AddCompanyTd = ({ company }: IProps) => {
  const dispatch = useDispatch()
  const { name, postalCode, address1, id } = company

  return (
    <tr>
      <td>{name}</td>
      <td>{postalCode}</td>
      <td>{address1}</td>
      <td>
        <button
          type="button"
          className="button is-primary"
          onClick={() => id && dispatch(setCompanyId(id))}
          style={{ width: "100%" }}
        >
          Choisir cette organisation
        </button>
      </td>
    </tr>
  )
}

export default AddCompanyTd
